import dayjs from "dayjs";
import { SiteWindowResponse } from "src/Data/Responses/SiteWindowResponse"
import { NoticeBlock } from "./NoticeBlock";

export interface NoticeBlocksProps {
    SiteTimeWindows: Array<SiteWindowResponse>
}

export function NoticeBlocks(props: NoticeBlocksProps) {
    let theseSiteTimeWindows: Array<SiteWindowResponse> = [];

    if (props.SiteTimeWindows !== undefined) {
        const PIT = dayjs();

        props.SiteTimeWindows.filter(th => th.IsMessage).forEach(STW => {
            const _from = dayjs(STW.WindowStart);
            const _to = dayjs(STW.WindowEnd);

            if (PIT.isAfter(_from) && PIT.isBefore(_to)) {
                theseSiteTimeWindows.push(STW);
            }
        });
    }

    return <>
        {theseSiteTimeWindows.map((STW, i) => {
            return <NoticeBlock key={"nb" + i.toString()} MessageBody={STW.MessageBody ?? ""} MessageTitle={STW.MessageTitle ?? ""} />
        })}
    </>
}